import { useCallback } from 'react';

export const useClarity = () => {
	return useCallback((command: string, ...args: any[]) => {
		if (typeof window === 'undefined' || !window.clarity) {
			return;
		}

		try {
			if (command === 'set') {
				for (const arg of args) {
					if (arg === null || arg === undefined) {
						continue;
					}

					if (typeof arg === 'object') {
						for (const [key, value] of Object.entries(arg)) {
							if (value !== null && value !== undefined) {
								window.clarity('set', key, value);
							}
						}
					} else {
						window.clarity('set', arg, arg);
					}
				}
				return;
			}

			if (command === 'identify' && args.length === 1) {
				const id = args[0];
				window.clarity('identify', id, null, null, id);
				return;
			}

			window.clarity(command, ...args);
		} catch {
			return;
		}
	}, []);
};
